import React from "react";
import { css } from "@emotion/react";
import { Div } from "@components/Markup";
import { Banner } from "./Banner";

const Hero = props => {
  return (
    <Div
      pt="sm"
      pb="sm"
      css={css`
        h1 {
          text-transform: capitalize;
        }
        iframe {
          pointer-events: none !important;
        }
      `}
    >
      <Banner {...props} />
    </Div>
  );
};

export default Hero;
